var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oldInnerWrapper tabContent", attrs: { id: "berichte1" } },
    [
      _c("form", [
        _c("label", [_vm._v("Titel")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.titleElement.text,
              expression: "titleElement.text"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          class: { error: _vm.errors.has("title") },
          attrs: {
            type: "text",
            name: "title",
            placeholder: "Titel...",
            maxlength: "90"
          },
          domProps: { value: _vm.titleElement.text },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.titleElement.text = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("label", { staticStyle: { "margin-top": "20px" } }, [
          _vm._v("Post")
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.postElement.text,
              expression: "postElement.text"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          class: { error: _vm.errors.has("post") },
          attrs: { name: "post", placeholder: "Dein Beitrag..." },
          domProps: { value: _vm.postElement.text },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.postElement.text = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "textAlignRight buttonBlockContainerRight" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-white teaserButton width50",
              attrs: { type: "button" },
              on: { click: _vm.cancel }
            },
            [_vm._v("Abbrechen")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              class: ["btn", "btn-white", "teaserButton", "width50"],
              attrs: { type: "button", disabled: _vm.errors.any() },
              on: { click: _vm.save }
            },
            [
              _c("span", [_vm._v("Speichern")]),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    { staticStyle: { width: "110px" } },
                    [
                      _c("double-bounce", {
                        attrs: { size: "12px", background: "#41bee6" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce97c246", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce97c246","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserContentReport.vue
// module id = 459
// module chunks = 2